import gql from "graphql-tag";

export const SERVICE_LOGIN = gql`
  query serviceLogin($employeeCode: String!, $password: String!) {
    serviceLogin(employeeCode: $employeeCode, password: $password) {
      accessToken
      sessionPeriod
      accessTokenPeriod
      contractCode
      currentUser {
        _id
        email
        phone
        ldapUser
        employee
        lastPasswordChange
        validFrom
        validTo
      }
      isTemporaryPassword
    }
  }
`;
